const { cxt } = require('./context');

const {
  sales,
} = require('../schema');

const {
  vxCore,
} = sales;

/**
 * Validates the VX Core Sales Split from incoming Sales Data
 * @type {Array<cxt>}
 * @memberof validators
 */
const salesVxSplitValidator = [
  cxt('schema', { schema: vxCore.split, opts: { nestedErrors: true } }),
];

/**
 * Validates the VX Core Sales Purpose from incoming Sales Data
 * @type {Array<cxt>}
 * @memberof validators
 */
const salesVxPurposeValidator = [
  cxt('schema', { schema: vxCore.purpose }),
];

/**
 * Validates the VX Core Sales Deposit from incoming Sales Data
 * @type {Array<cxt>}
 * @memberof validators
 */
const salesVxDepositValidator = [
  cxt('schema', { schema: vxCore.deposit }),
];

/**
 * Validates the VX Core Sales Disbursement Purpose from incoming Sales Data
 * @type {Array<cxt>}
 * @memberof validators
 */
const salesVxDisbursementPurposeValidator = [
  cxt('schema', { schema: vxCore.disbursementPurpose }),
];

/**
 * Validates the VX Core Sales Receipt from incoming Sales Data
 * @type {Array<cxt>}
 * @memberof validators
 */
const salesVxReceiptValidator = [
  cxt('schema', { schema: vxCore.receipt }),
];

/**
 * Validates the VX Core Sales Attach Member to Application from incoming Sales Data
 * @type {Array<cxt>}
 * @memberof validators
 */
const salesVxAttachMemberValidator = [
  cxt('schema', { schema: vxCore.attachMember }),
];

/**
 * Validates the VX Core Sales Attach Member to Application from incoming Sales Data
 * @type {Array<cxt>}
 * @memberof validators
 */
const salesVxSecurityValidator = [
  cxt('schema', { schema: vxCore.security, opts: { nestedErrors: true } }),
];

/**
 * Validates the VX Core Sales Fee configuration Data to get the amount
 * @type {Array<cxt>}
 * @memberof validators
 */
const salesVxFeeConfigLookupValidator = [
  cxt('schema', { schema: vxCore.feeConfig, opts: { nestedErrors: true } }),
];

module.exports = {
  salesVxSplit: salesVxSplitValidator,
  salesVxDisbursementPurpose: salesVxDisbursementPurposeValidator,
  salesVxPurpose: salesVxPurposeValidator,
  salesVxDeposit: salesVxDepositValidator,
  salesVxReceipt: salesVxReceiptValidator,
  salesVxAttachMember: salesVxAttachMemberValidator,
  salesVxSecurity: salesVxSecurityValidator,
  salesVxFeeConfig: salesVxFeeConfigLookupValidator,
};
